// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/script.proto (package squareup.common.script, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file squareup/common/script.proto.
 */
export const file_squareup_common_script: GenFile = /*@__PURE__*/
  fileDesc("ChxzcXVhcmV1cC9jb21tb24vc2NyaXB0LnByb3RvEhZzcXVhcmV1cC5jb21tb24uc2NyaXB0KkoKBlNjcmlwdBIJCgRaeXl5EOYHEgkKBEhhbmkQ9AMSCQoESGlyYRCaAxIJCgRKcGFuEJ0DEgkKBEthbmEQmwMSCQoETGF0bhDXAUIjCiFjb20uc3F1YXJldXAucHJvdG9zLmNvbW1vbi5zY3JpcHQ");

/**
 * A script that can be used to write a name. These come from ISO15924
 * (http://unicode.org/iso15924/iso15924-codes.html), but we will add them as we need them.
 * Sorted by script name, except for Zyyy.
 *
 * @generated from enum squareup.common.script.Script
 */
export enum Script {
  /**
   * Undetermined script.  This is listed first in the .proto file so that it's
   * the default for an unrecognized or unset script enum.
   *
   * @generated from enum value: Zyyy = 998;
   */
  Zyyy = 998,

  /**
   * Han script as used for Imperial Chinese, Kanji, and Hanja.
   * This does not include simplified Han or traditional Han, which have
   * their own enums in ISO-15924. They are not currently used in this API.
   *
   * @generated from enum value: Hani = 500;
   */
  Hani = 500,

  /**
   * Hiragana.
   *
   * @generated from enum value: Hira = 410;
   */
  Hira = 410,

  /**
   * Japanese writing scripts: Han (Kanji) + Kiragana + Katakana
   *
   * @generated from enum value: Jpan = 413;
   */
  Jpan = 413,

  /**
   * Katakana.
   *
   * @generated from enum value: Kana = 411;
   */
  Kana = 411,

  /**
   * Latin script, such as for many Western languages or Romaji.
   *
   * @generated from enum value: Latn = 215;
   */
  Latn = 215,
}

/**
 * Describes the enum squareup.common.script.Script.
 */
export const ScriptSchema: GenEnum<Script> = /*@__PURE__*/
  enumDesc(file_squareup_common_script, 0);

